import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import SearchIcon from '@mui/icons-material/Search';
import * as XLSX from 'xlsx';
import { fetchData, deleteData, activateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { IconButton } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { Link } from 'react-router-dom';
import Button from '@mui/material/Button';
import RefreshIcon from '@mui/icons-material/Refresh';
import FeedIcon from '@mui/icons-material/Feed';
import Select from 'react-select';
import CopyrightIcon from '@mui/icons-material/Copyright';
import CircularProgress from '@mui/material/CircularProgress';


function StockTransfer() {
    const [dataBill, setDataBill] = useState([]);
    const [dataItem, setDataItem] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    const tableRef = React.createRef();
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');

    const [itemOptions, setItemOptions] = useState([]);
    const [selectedItem, setSelectedItem] = useState(null);
    const [itemId, setItem] = useState(0);
    const [isFocused, setIsFocused] = useState(false);

    const [branchOptions, setBranchOptions] = useState([]);
    const [selectedBranch, setSelectedBranch] = useState(null);
    // const [branchId, setBranch] = useState(0);

    const { isAuthenticated, companyId, branchId, permissions, token, logout } = useAuth();

    const [OrionQty, setOrionQty] = useState(0);
    const [UbcityQty, setUbcityQty] = useState(0);
    const [PMCChennaiQty, setPMCChennaiQty] = useState(0);
    const [PMCBangaloreQty, setPMCBangaloreQty] = useState(0);
    const [HYDForumQty, setHYDForumQty] = useState(0);
    const [InorbitQty, setInorbitQty] = useState(0);
    const [LandTQty, setLandTQty] = useState(0);
    const [VRQty, setVRQty] = useState(0);
    const [ShantiniketanQty, setShantiniketanQty] = useState(0);
    const [HeadOfficeQty, setHeadOfficeQty] = useState(0);


    const [selectedOption, setSelectedOption] = useState('out');

    useEffect(() => {
        let OrionQty = 0;
        let UbcityQty = 0;
        let PMCChennaiQty = 0;
        let PMCBangaloreQty = 0;
        let HYDForumQty = 0;
        let InorbitQty = 0;
        let LandTQty = 0;
        let VRQty = 0;
        let ShantiniketanQty = 0;
        let HeadOfficeQty = 0;

        dataItem.forEach(item => {
            OrionQty += item.OrionQty;
            UbcityQty += item.UbcityQty;
            PMCChennaiQty += item.PMCChennaiQty;
            PMCBangaloreQty += item.PMCBangaloreQty;
            HYDForumQty += item.HYDForumQty;
            InorbitQty += item.InorbitQty;
            LandTQty += item.LandTQty;
            VRQty += item.VRQty;
            ShantiniketanQty += item.ShantiniketanQty;
            HeadOfficeQty += item.HeadOfficeQty;
        });

        setOrionQty(OrionQty);
        setUbcityQty(UbcityQty);
        setPMCChennaiQty(PMCChennaiQty);
        setPMCBangaloreQty(PMCBangaloreQty);
        setHYDForumQty(HYDForumQty);
        setInorbitQty(InorbitQty);
        setLandTQty(LandTQty);
        setVRQty(VRQty);
        setShantiniketanQty(ShantiniketanQty);
        setHeadOfficeQty(HeadOfficeQty);

    }, [dataItem]);

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        setFromDate(getFormattedStartDate());
        setToDate(getFormattedCurrentDate());
        fetchTableData();
        fetchBranchData();
        fetchItemData();
    }, [isAuthenticated, companyId, token, logout]);

    const handleBranchSelect = (selectedOption) => {
        setSelectedBranch(selectedOption);
        const branchId = selectedOption ? selectedOption.value : '';
        setBranch(branchId);
        setDataItem([])
    };

    const handleItemSelect = (selectedOption) => {
        setSelectedItem(selectedOption);
        const itemId = selectedOption ? selectedOption.value : '';
        setItem(itemId);
        setDataItem([])
    };



    const fetchBranchData = () => {
        fetchData('ReportApi', `/Branch/${companyId}/${branchId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                const options = data.map((customer) => ({
                    label: customer.Name,
                    value: customer.Id,
                }));
                setBranchOptions(options);
            })
            .catch((error) => {
                console.error('Error fetching branch data:', error);
            });
    };

    const fetchItemData = () => {
        fetchData('ReportApi', `/Item/${companyId}/${branchId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                const options = data.map((customer) => ({
                    label: customer.Code + '-' + customer.Name,
                    value: customer.Id,
                }));
                setItemOptions(options);
            })
            .catch((error) => {
                console.error('Error fetching branch data:', error);
            });
    };

    const getFormattedCurrentDate = () => {
        const currentDate = new Date();
        return currentDate.toISOString().split('T')[0];
    };

    const getFormattedStartDate = () => {
        const monthStartDate = new Date();
        monthStartDate.setDate(1);
        return monthStartDate.toISOString().split('T')[0];
    };

    const handleFromDateChange = (e) => {
        const selectedDate = e.target.value;
        setFromDate(selectedDate);
    };

    const handleToDateChange = (e) => {
        const selectedDate = e.target.value;
        setToDate(selectedDate);
    };

    const hasReadReportPermission = permissions.includes('Read Reports');
    const [loading, setLoading] = useState(false);

    const handleChange = (event) => {
        setSelectedOption(event.target.value);
        setDataItem([])
    };

    const fetchTableData = async () => {
        if (hasReadReportPermission) {
            setDataItem([])
            setLoading(true);
            try {


                if (selectedOption === 'out') {
                    const response = await fetchData('ReportApi', `/StockTransferout/${fromDate}/${toDate}/${companyId}/${branchId}/${itemId}`, token);
                    if (response.responseCode === '1111') {
                        setDataItem(response.response_data);
                    }
                } else if (selectedOption === 'in') {
                    const response = await fetchData('ReportApi', `/StockTransferint/${fromDate}/${toDate}/${companyId}/${branchId}/${itemId}`, token);
                    if (response.responseCode === '1111') {
                        setDataItem(response.response_data);
                    }
                }

            } catch (error) {
                console.error('Error fetching Sales Details:', error);
            }
            finally {
                setLoading(false); // Hide loading screen
            }
        }
    };

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    const filteredDataBill = dataBill.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const filteredDataItem = dataItem.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        return new Date(dateString).toLocaleDateString('en-GB', options);
    };



    const handleExportExcel = () => {

        const excelData = [];
        if (selectedOption === 'out') {
            const headerCaption = [`Stock Transfer Out From : ${formatDate(fromDate)} To : ${formatDate(toDate)}`];
            excelData.push(headerCaption);
        } else if (selectedOption === 'in') {
            const headerCaption = [`Stock Transfer In From : ${formatDate(fromDate)} To : ${formatDate(toDate)}`];
            excelData.push(headerCaption);
        }


        const headerRow = ['Code', 'Item', 'Purchase Rate', 'MRP', 'GST%', 'HSN Code', 'PG', 'IG', 'ISG', 'PF', 'Category', 'Group',
            'UB City', 'Orion Mall', 'PMC Chennai', 'PMC Bangalore', 'Inorbit Mall', 'L&T Metro Mall', 'VR Mall', 'Hyderabad Forum', 'Shantiniketan', 'Ecomm'
        ];
        excelData.push(headerRow);
        filteredDataItem.forEach((rowData, index) => {
            const dataRow = [];
            dataRow.push(parseFloat(rowData.Code), rowData.Name, parseFloat(rowData.PurchaseRate.toFixed(2)), parseFloat(rowData.MRP.toFixed(2)), rowData.GSTRate, rowData.HSNCode, rowData.PG, rowData.IG, rowData.ISG, rowData.PF, rowData.CategoryName, rowData.ItemGroupName,
                rowData.UbcityQty, rowData.OrionQty, rowData.PMCChennaiQty, rowData.PMCBangaloreQty, rowData.InorbitQty, rowData.LandTQty, rowData.VRQty, rowData.HYDForumQty, rowData.ShantiniketanQty, rowData.HeadOfficeQty
            );
            excelData.push(dataRow);
        });
        // Add total row
        const totalRow = ['', 'Total', '', '', '', '', '', '', '', '', '', '', UbcityQty, OrionQty, PMCChennaiQty, PMCBangaloreQty, InorbitQty, LandTQty, VRQty, HYDForumQty, ShantiniketanQty, HeadOfficeQty];
        excelData.push(totalRow);
        const ws = XLSX.utils.aoa_to_sheet(excelData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Stock');
        XLSX.writeFile(wb, 'Stock_Transfer.xlsx');
    };




    const handlePrint = () => {

    };

    // Function to get the number of rows for a party name
    const getRowCount = (PackingListId) => {
        return filteredDataItem.filter(row => row.PackingListId === PackingListId).length;
    };

    // Function to calculate total for a specific field within a party group
    const calculateTotal = (data, BillNo, field) => {
        // Filter the data for the given party name
        const partyData = data.filter(item => item.BillNo === BillNo);

        // Calculate the total for the specified field within the party group
        return partyData.reduce((total, item) => total + item[field], 0);
    };

    const itemOptionsWithBlank = [{ label: '--Select--', value: 0 }, ...itemOptions];
    const branchOptionsWithBlank = [{ label: '--Select--', value: 0 }, ...branchOptions];

    return (
        <div className="w-full  mx-auto" style={{ width: '95%', marginTop: '10px' }}>
            <div style={{ width: '100%', marginBottom: '2', display: 'flex', flexWrap: 'nowrap', alignItems: 'center' }}>
                {/* <h5 className="block uppercase tracking-wide text-black productHead flex-grow linkcolor" style={{ flexGrow: 1, color: 'linkColor', whiteSpace: 'nowrap', marginRight: '8px' }}>Stock Transfer Report</h5> */}
                <div className='w-full mb-2 flex' style={{ marginTop: '10px' }}>
                    <h6 className="block uppercase tracking-wide text-black productHead flex-grow linkcolor" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black', width: '300px' }}>
                        Stock Transfer
                    </h6>
                </div>

                <div className='w-full mb-2 flex' style={{ marginTop: '10px', marginLeft: '20px' }}>
                    {/* <div className="mr-2 text-white" style={{ display: 'flex', alignItems: 'center', marginTop: '30px' }}> */}
                    <RadioGroup
                        aria-label="viewOption"
                        name="viewOption"
                        value={selectedOption}
                        onChange={handleChange}
                        style={{ marginLeft: '10px', display: 'flex', flexDirection: 'row' }} // Set flexDirection to 'row'
                    >
                        <FormControlLabel value="out" control={<Radio />} className='text-black' label="Out" />
                        <FormControlLabel value="in" control={<Radio />} className='text-black' label="In" />
                    </RadioGroup>
                    {/* </div> */}
                </div>

                <div className='w-full mb-2 flex' style={{ marginTop: '10px', marginLeft: '55px' }}>

                    {loading && (
                        <div style={{
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            backgroundColor: 'rgba(0, 0, 0, 0.5)',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            zIndex: 9999
                        }}>
                            <div>
                                <CircularProgress style={{ color: 'white' }} />
                                <span style={{ color: 'white', marginTop: '10px', display: 'block' }}>Loading...</span>
                            </div>
                        </div>
                    )}

                    <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'left', marginTop: '17px' }}>
                        <input
                            className="shadow text-gray-700 leading-tight"
                            type="text"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                            onFocus={() => setIsFocused(true)}
                            onBlur={() => setIsFocused(false)}
                            style={{
                                width: isFocused ? '270px' : '200px',
                                height: '30px',
                                border: '1px solid #ccc',
                                borderRadius: '15px',
                                padding: '0 20px',
                                transition: 'width 0.4s ease-in-out, border-color 0.3s ease-in-out',
                                outline: 'none',
                                borderColor: isFocused ? 'darkcyan' : '#ccc',
                                boxShadow: isFocused ? '0 4px 8px rgba(0, 0, 0, 0.2)' : 'none',
                            }}
                        />
                    </div>

                    <Button
                        style={{ color: "black", height: '36px', marginLeft: '10px', marginTop: '10px' }}
                        onClick={fetchTableData}
                        className="linkcolor"
                    >
                        <IconButton onClick={fetchTableData}>
                            {/* <RefreshIcon style={{ color: 'brown' }} /> */}
                        </IconButton>
                        <span style={{ color: 'brown', fontWeight: 'bolder', fontSize: '12px' }}>Refresh</span>
                    </Button>
                    <Button
                        style={{ color: "black", height: '36px', marginLeft: '10px', marginTop: '10px' }}
                        onClick={handleExportExcel}
                        className="linkcolor"
                    >
                        <IconButton onClick={handleExportExcel}>
                            {/* <FeedIcon style={{ color: 'darkgreen' }} /> */}
                        </IconButton>
                        <span style={{ color: 'darkgreen', fontWeight: 'bolder', fontSize: '12px' }}>Excel</span>
                    </Button>

                    <div className="watermark">
                        <CopyrightIcon /><b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
                    </div>

                </div>



                <div style={{ marginRight: '2', maxWidth: '150px', marginLeft: '10px' }}>
                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ fontSize: '10px' }}>
                        From Date
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                        type="date" value={fromDate} onChange={handleFromDateChange}
                        style={{ marginTop: '-10px', shadow: 'appearance-none', border: 'rounded', width: '100%', paddingY: '2', paddingX: '3', color: 'gray-700', leadingTight: true, focus: { color: 'gray-600', shadow: 'outline' } }}
                    />
                </div>
                <div style={{ marginRight: '2', maxWidth: '150px', marginLeft: '10px' }}>
                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ fontSize: '10px' }}>
                        To Date
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                        type="date" value={toDate} onChange={handleToDateChange}
                        style={{ marginTop: '-10px', shadow: 'appearance-none', border: 'rounded', width: '100%', paddingY: '2', paddingX: '3', color: 'gray-700', leadingTight: true, focus: { color: 'gray-600', shadow: 'outline' } }}
                    />
                </div>
            </div>

            <div className="watermark">
                <CopyrightIcon /><b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
            </div>


            <div className='w-full mb-5 flex' style={{ maxHeight: '550px', overflowY: 'auto', marginTop: '7px' }}>
                <TableContainer component={Paper}>
                    <Table stickyHeader>
                        <TableHead sx={{ backgroundColor: '#08396B', Width: '2500px' }}>
                            <TableRow sx={{ whiteSpace: 'nowrap' }}>
                                <TableCell sx={{ background: 'linear-gradient(to right, #78a7b6ff, #063e68ff)', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>Code</TableCell>
                                <TableCell sx={{ background: 'linear-gradient(to right, #78a7b6ff, #063e68ff)', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>Item</TableCell>
                                <TableCell sx={{ background: 'linear-gradient(to right, #78a7b6ff, #063e68ff)', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase', textAlign: 'left' }}>Purchase Rate</TableCell>
                                <TableCell sx={{ background: 'linear-gradient(to right, #78a7b6ff, #063e68ff)', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase', textAlign: 'left' }}>MRP</TableCell>
                                <TableCell sx={{ background: 'linear-gradient(to right, #78a7b6ff, #063e68ff)', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase', textAlign: 'center' }}>GST%</TableCell>
                                <TableCell sx={{ background: 'linear-gradient(to right, #78a7b6ff, #063e68ff)', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase', textAlign: 'center' }}>HSN Code</TableCell>
                                <TableCell sx={{ background: 'linear-gradient(to right, #78a7b6ff, #063e68ff)', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase', textAlign: 'center' }}>PG</TableCell>
                                <TableCell sx={{ background: 'linear-gradient(to right, #78a7b6ff, #063e68ff)', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase', textAlign: 'center' }}>IG</TableCell>
                                <TableCell sx={{ background: 'linear-gradient(to right, #78a7b6ff, #063e68ff)', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase', textAlign: 'center' }}>ISG</TableCell>
                                <TableCell sx={{ background: 'linear-gradient(to right, #78a7b6ff, #063e68ff)', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase', textAlign: 'center' }}>PF</TableCell>
                                <TableCell sx={{ background: 'linear-gradient(to right, #78a7b6ff, #063e68ff)', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase', textAlign: 'center' }}>Category</TableCell>
                                <TableCell sx={{ background: 'linear-gradient(to right, #78a7b6ff, #063e68ff)', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase', textAlign: 'center' }}>Group</TableCell>
                                <TableCell sx={{ background: 'linear-gradient(to right, #78a7b6ff, #063e68ff)', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase', textAlign: 'center' }}>UB City</TableCell>
                                <TableCell sx={{ background: 'linear-gradient(to right, #78a7b6ff, #063e68ff)', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase', textAlign: 'center' }}>Orion Mall</TableCell>
                                <TableCell sx={{ background: 'linear-gradient(to right, #78a7b6ff, #063e68ff)', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase', textAlign: 'center' }}>PMC Chennai</TableCell>
                                <TableCell sx={{ background: 'linear-gradient(to right, #78a7b6ff, #063e68ff)', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase', textAlign: 'center' }}>PMC Bangalore</TableCell>
                                <TableCell sx={{ background: 'linear-gradient(to right, #78a7b6ff, #063e68ff)', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase', textAlign: 'center' }}>Inorbit Mall</TableCell>
                                <TableCell sx={{ background: 'linear-gradient(to right, #78a7b6ff, #063e68ff)', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase', textAlign: 'center' }}>L&T Metro Mall</TableCell>
                                <TableCell sx={{ background: 'linear-gradient(to right, #78a7b6ff, #063e68ff)', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase', textAlign: 'center' }}>VR Mall</TableCell>
                                <TableCell sx={{ background: 'linear-gradient(to right, #78a7b6ff, #063e68ff)', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase', textAlign: 'center' }}>Hyderabad Forum</TableCell>
                                <TableCell sx={{ background: 'linear-gradient(to right, #78a7b6ff, #063e68ff)', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase', textAlign: 'center' }}>Shantiniketan</TableCell>
                                <TableCell sx={{ background: 'linear-gradient(to right, #78a7b6ff, #063e68ff)', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase', textAlign: 'center' }}>Ecomm</TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody sx={{ backgroundColor: 'whitesmoke' }}>
                            {filteredDataItem.map((data, index) => (
                                <TableRow
                                    key={data.id}
                                    className={'highlighted-row'}
                                    sx={{
                                        padding: '5px',
                                        height: '52px',

                                        backgroundColor: 'transparent',

                                    }}
                                >
                                    <TableCell sx={{ borderBottom: '1px solid black', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px' }}>{data.Code}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px' }}>{data.Name}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'right', fontSize: '12px' }}>{data.PurchaseRate.toFixed(2)}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'right', fontSize: '12px' }}>{data.MRP.toFixed(2)}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'center', fontSize: '12px' }}>{data.GSTRate}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'center', fontSize: '12px' }}>{data.HSNCode}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'center', fontSize: '12px' }}>{data.PG}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'center', fontSize: '12px' }}>{data.IG}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'center', fontSize: '12px' }}>{data.ISG}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'center', fontSize: '12px' }}>{data.PF}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'center', fontSize: '12px' }}>{data.CategoryName}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'center', fontSize: '12px' }}>{data.ItemGroupName}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'center', fontSize: '12px' }}>{data.UbcityQty}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'center', fontSize: '12px' }}>{data.OrionQty}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'center', fontSize: '12px' }}>{data.PMCChennaiQty}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'center', fontSize: '12px' }}>{data.PMCBangaloreQty}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'center', fontSize: '12px' }}>{data.InorbitQty}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'center', fontSize: '12px' }}>{data.LandTQty}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'center', fontSize: '12px' }}>{data.VRQty}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'center', fontSize: '12px' }}>{data.HYDForumQty}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'center', fontSize: '12px' }}>{data.ShantiniketanQty}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'center', fontSize: '12px' }}>{data.HeadOfficeQty}</TableCell>
                                </TableRow>
                            ))}

                            <TableRow
                                className={'highlighted-row'}
                                sx={{
                                    padding: '7px',
                                    height: '52px',
                                    background: 'linear-gradient(to right, #063e68ff, #063e68ff)',

                                }}
                            >
                                <TableCell colSpan={12} />
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'center' }}>{UbcityQty.toFixed(2)}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'center' }}>{OrionQty.toFixed(2)}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'center' }}>{PMCChennaiQty.toFixed(2)}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'center' }}>{PMCBangaloreQty.toFixed(2)}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'center' }}>{InorbitQty.toFixed(2)}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'center' }}>{LandTQty.toFixed(2)}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'center' }}>{VRQty.toFixed(2)}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'center' }}>{HYDForumQty.toFixed(2)}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'center' }}>{ShantiniketanQty.toFixed(2)}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'center' }}>{HeadOfficeQty.toFixed(2)}</TableCell>
                            </TableRow>

                        </TableBody>

                    </Table>
                </TableContainer>
            </div>
        </div >
    );
}

export default StockTransfer;
